import { inject, Injectable } from '@angular/core';
import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, } from '@angular/common/http';
import { catchError, Observable, throwError } from 'rxjs';
import { environment } from 'src/environments/environment';
import { AuthService } from '@app/core/auth/auth.service';
import { createLogger } from '@app/shared/util/logger';

const { log } = createLogger('auth.interceptor');

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  readonly #auth = inject(AuthService);

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    if (req.url.includes(environment.backendUrl)) {
      log('adding token', req.url);

      const modifiedReq = req.clone({
        setHeaders: {
          Authorization: `Bearer ${this.#auth.idToken()}`,
        },
      });

      return next.handle(modifiedReq).pipe(
        catchError((error: HttpErrorResponse) => {
          if (error.status === 401) {
            log('unauthorized - redirecting to login');
            this.#auth.logout(true);
          }

          return throwError(() => error);
        })
      );
    }

    return next.handle(req);
  }
}
